import { useCallback } from 'react';
import { useApp, useAppDispatch } from '@context/AppContext';

export const useOnboardingControls = () => {
  const { isOnboardingClosed } = useApp();
  const { setOnboardingClosed, setOnboardingCollapsed } = useAppDispatch();

  const openOnboarding = useCallback(() => {
    setOnboardingClosed(false);
    setOnboardingCollapsed(false);
  }, [setOnboardingClosed, setOnboardingCollapsed]);

  const closeOnboarding = useCallback(() => {
    setOnboardingClosed(true);
  }, [setOnboardingClosed]);

  const isOnboardingClosedCheck = useCallback(() => {
    return isOnboardingClosed;
  }, [isOnboardingClosed]);

  return {
    openOnboarding,
    closeOnboarding,
    isOnboardingClosed: isOnboardingClosedCheck,
  };
};
